module.exports = __webpack_public_path__ + "img/logo_200x160.92470203.png";